/* eslint-disable @typescript-eslint/no-explicit-any */
import CustomLink from '../../common/CustomLink/CustomLink';
import Markdown from '../../common/Markdown/Markdown';
import NoTagRenderer from '../../common/NoTagRenderer/NoTagRenderer';
import { TBackground, addBackground } from '../../core/helpers';
import { ILink } from '../../core/models';
import './Introduction.css';

interface IProps {
  title: string;
  desc?: string;
  cta?: ILink;
  background?: TBackground;
}

function Introduction({ title, desc, cta, background }: IProps) {
  return (
    <section
      className={`introduction${background ? ' section-bg' : ' section'}`}
      {...addBackground({ img: undefined, gradient: background })}
    >
      <div className="wrap wrap--lg">
        <div className="introduction__container gap-lg">
          <div className="introduction__left">
            <h2 className="introduction__title h2">
              <Markdown
                components={{
                  p: NoTagRenderer,
                }}
              >
                {title}
              </Markdown>
            </h2>
          </div>
          <div className="introduction__right gap-md">
            {!desc ? null : <Markdown className="introduction__desc markdown h3">{desc}</Markdown>}
            {!cta ? null : <CustomLink className="introduction__cta" link={cta} />}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Introduction;
